<template>
  <div class="setting-container">
    <span class="setting-title">个人设置</span>
    <div class="user-icon-view">
      <div class="title-icon">
        <span class="head-title">头像</span>
        <span class="break-row"/>
        <img :src="imgUrl" class="icon" @error="errorLoadImg()"/>
      </div>
      <div class="btn-view">
        <label class="input-icon">
          <input @change="onFileChange($event)" type="file" class="modify-user-icon-input">修改
        </label>
      </div>
    </div>
    <!-- <div class="password-view">
      <div class="title-icon">
        <span class="head-title">登录密码</span>
        <span class="break-row"/>
        <span class="pwd">********</span>
      </div>
      <div @click="showModifyPasswordView" class="btn-view">修改</div>
    </div> -->
    <div class="submit-view">
      <div @click="logout" class="submit">退出登录</div>
    </div>
    <ModifyPassword v-show="$store.state.user.setting.show_modify_password_view"/>
  </div>
</template>

<script>
import MyCookies from '@/utils/my_cookies'
import ModifyPassword from './modify_password'
import DEFAULT_IMG from '../../../static/img/header/user_icon.png'

export default {
  name: 'Setting',
  components: {
    ModifyPassword
  },
  data () {
    return {
      pic_file:　'',
      image: '',
      formData: ''
    }
  },
  computed: {
    imgUrl () {
      return this.$store.state.avatar_url === '' ? DEFAULT_IMG : this.$store.state.avatar_url
    }
  },
  methods: {
    /**
     * 显示隐藏修改密码框,key用来区分确认或者取消
     */
    showModifyPasswordView () {
      this.$store.commit('toggle_show_modify_password_view')
    },
    /**
     * 退出登录
     */
    logout () {
      // 清除用户cookie信息，-1的意思让cookie过期
      
      this.$store.commit('clear_shopping_cart_data')
      // 登出
      this.APIS.LOGOUT()
      .then((res) => {
        // 跳转到登录界面
        this.$router.push('/p/login')
        MyCookies.setCookie('user_info', '', -1, '/p')
        localStorage.removeItem('userInfo')
      })
      .catch((err) => {
        console.log(err)
      })
    },
    /**
     * 选择图片时触发的事件
     */
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      this.pic_file = e.target.files[0]
      let supportedTypes = ['image/jpg', 'image/jpeg', 'image/png'];
      let imagSize =  this.pic_file.size;
      if (imagSize <= 102400) {
        if (files && supportedTypes.indexOf(files[0].type) >= 0) {
          this.createImage(files, e)
        } else {
          this.$store.commit('show_alert', '图片格式只支持：jpg、jpeg 和 png哦')
        }
      } else {
        this.$store.commit('show_alert', '上传的图片不能超过100KB哦')
      }
    },
    /**
     * 创建图片
     */
    createImage (file, e) {
      e.preventDefault();
      var _this = this
      _this.image = []
      var reader = null
      var leng = file.length
      for (var i = 0; i < leng; i++) {
        reader = new window.FileReader()
        reader.readAsDataURL(file[i])
        reader.onload = function (e) {
          _this.img_change = false
          _this.image.push(e.target.result)
        }
      }
      this.formData  = new FormData();
      this.formData.append('flag', "change_avator");
      this.formData.append('user_id', _this.$store.state.user_info.id);
      this.formData.append('file', _this.pic_file);
      this.midifyAvatar()
    },
    /**
     * 发起修改头像请求
     */
    midifyAvatar () {
      this.APIS.MODIFY_AVATAR(this.formData)
      .then(res => {
        if ( res.data.status == 0 ) {
          // 更换头像url
          this.$store.commit('set_avatar_url', res.data.new_icon_url)
          this.$store.commit('show_alert', '更换头像成功')
        } else {
          this.$store.commit('show_alert', '更换头像失败')
        }
      })
      .catch((err) => {
        this.$store.commit('show_alert', '更换头像失败')
      })
    },
    /**
     * 默认图片
     */
    errorLoadImg () {
      const eventTag = event.toElement || event.target;
      eventTag.src = "../../../static/img/header/user_icon.png"
    }
  }
}
</script>

<style lang="less" scoped>
.setting-container {
  width: 900px;
  margin-top: 30px;
  .setting-title {
    font-size: 20px;
    color: #333333;
  }
  .break-line {
    width: 100%;
    margin-top: 20px;
    border-bottom: 1px solid #e0e0e0;
  }
  .user-icon-view, .password-view {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    .title-icon {
      width: 300px;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      .head-title {
        width: 80px;
        display: flex;
        justify-content: flex-end;
        font-size: 18px;
        color: #333333;
      }
      .break-row {
        width: 1px;
        height: 30px;
        margin-left: 40px;
        background-color: #e0e0e0;
      }
      .pwd {
        font-size: 18px;
        color: #333333;
        margin-left: 30px;
      }
      .icon {
        width: 50px;
        height: 50px;
        margin-left: 30px;
        border-radius: 25px;
      }
    }
    .btn-view {
      width: 84px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ffffff;
      border-radius: 20px;
      font-size: 18px;
      color: #999999;
      cursor: pointer;
      border: solid 1px #e0e0e0;
      .input-icon {
        cursor: pointer;
        .modify-user-icon-input {
          display: none;
          cursor: pointer;
        }
      }
      
    }
  }
  .user-icon-view {
    margin-top: 20px;
  }
  
  .password-view {
    width: 100%;
    height: 100px;
    border-bottom: 1px solid #e0e0e0;
  }
  .submit-view {
    width: 100%;
    height: 54px;
    display: flex;
    justify-content: center;
    .submit {
      width: 240px;
      height: 54px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 50px;
      font-size: 18px;
      color: #ffffff;
      background-color: #ff9a28;
      border-radius: 27px;
      cursor: pointer;
    }
    .submit:hover {
      background-color: #f08710;
    }
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/user/setting.vue